import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {CustomComponent, Link} from '../../common/components';

import './Tag.scss';

const TAG_COLORS = [
    '#8BB3A6',
    '#8BB398',
    '#8BB38B',
    '#98B38B',
    '#A6B38B',
    '#B3B38B',
    '#B3A68B',
    '#B38B98',
    '#B38B8B',
    '#B38BA6',
    '#B38BB3',
    '#A68BB3',
    '#988BB3',
    '#8B8BB3',
    '#8B98B3',
    '#8BA6B3',
    '#8BB3B3',
];
Object.freeze(TAG_COLORS);

type SearchTagProps = {
    tag: {
        image?: string,
        url?: string,
        name?: string,
        searchterm?: string,
    };
}


export class SearchTag extends CustomComponent<SearchTagProps> {
    render() {
        const {tag} = this.props;
        const {image, url, name, searchterm} = tag;
        return (
            <Link
                to={url || this.linkToSearch(searchterm.split(' '))}
                className="SearchTag"
                style={{
                    'background-image': `url('${image}')`,
                }}
            >
                <span>{name || searchterm}</span>
            </Link>
        );
    }
}

export class RelatedTag extends CustomComponent {
    render() {
        const {url, name, searchterm, onClick} = this.props;
        const idx = (
            searchterm.charCodeAt(searchterm.length - 1) +
            searchterm.charCodeAt(0)
        ) % TAG_COLORS.length;
        const color = TAG_COLORS[idx];
        return (
            <Link to={url || this.linkToSearch(searchterm.split(' '))} onClick={onClick}>
                <div
                    className="RelatedTag"
                    style={{
                        'background-color': color,
                    }}
                >
                    {name || searchterm}
                </div>
            </Link>
        );
    }
}

export class TrendsTag extends CustomComponent {
    render() {
        const {tag, onClick} = this.props;
        let percentChange = tag.percent_change || 0;
        const pos = percentChange > 0;
        const arrow = pos ? '\u2b06' : '\u2b07';
        percentChange = Math.ceil(Math.abs(percentChange));
        const imageUrl = tag.image;
        return (
            <div className="TrendsTag">
                <Link to={this.linkToSearch(tag.searchterm)} onClick={onClick}>
                    <img className="img" src={imageUrl} loading="lazy" />
                    <div className="info">
                        {tag.searchterm}
                        {pos && <span className={`percentage-change ${pos ? 'positive' : 'negative'}`}>{arrow} {percentChange}%</span>}
                    </div>
                </Link>
            </div>
        );
    }
}
